<template>
    <v-container>
        <v-dialog fullscreen v-model="showLogin" max-width="500px">
            <v-card height="100%" class="d-flex align-center" style="overflow-x: hidden">
                <v-row>
                    <v-col lg="4" offset-lg="4" xs="12">
                        <v-card-title class="headline" primary-title>
                            Reset Password
                        </v-card-title>
                        <v-card-text v-if="!emailSent">
                            <v-form @submit.prevent="handleSendEmail" v-model="isValid">
                                <v-text-field outlined dense hide-details class="pb-2"
                                        label="E-mail"
                                        v-model="email"
                                        :rules="[rules.required, rules.email]"
                                ></v-text-field>
                            </v-form>
                            <v-btn depressed block color="primary" :disabled="!isValid" @click.stop="handleSendEmail">Send Email</v-btn>
                        </v-card-text>
                        <v-card-text v-if="emailSent">
                            <v-alert outlined color="success" icon="mdi-check-circle" :value="true">
                                An email has been sent
                            </v-alert>
                            Please check your email to reset your password and then
                            <router-link to="login">login.</router-link>
                        </v-card-text>
                        <v-card-text v-if="emailError">
                            <v-alert outlined color="error" icon="mdi-alert-circle" :value="true">
                                {{emailErrorMessage}}
                            </v-alert>
                        </v-card-text>
                    </v-col>
                </v-row>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
  import {auth} from 'firebase'
  import gx from 'vue'

  export default {
    name: 'ForgotPassword',

    data() {
      return {
        isValid: false,
        emailSent: false,
        emailError: false,
        emailErrorMessage: '',
        showLogin: true,
        email: '',
        rules: {
          required: (value) => !!value || 'Required.',
          email: (value) => {
            var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          }
        }
      }
    },

    methods: {
      handleSendEmail() {
        auth().sendPasswordResetEmail(this.email).then(() => {
          this.emailSent = true;
        }).catch((error) => {
          // An error happened.
          this.emailError = true;
          this.emailErrorMessage = error.message;
        });
      }
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
